import FloatingWhats from "../Components/FloatingWhats.jsx";
import Header from "../Components/Header.jsx";
import React, { useState } from "react";
import { Box, Button, Grid2, IconButton, Modal } from "@mui/material";
import BottomBar from "../Components/BottomBar.jsx";
import Footer from "../Components/Footer.jsx";
import styles from "../styles/ProdCel.css"
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Card from "../Components/Card.jsx";

const images = [
    "/images/brc3d-1.png",
    "/images/brc3d-2.png",
    "/images/brc3d-3.png",
];

const ProdCelBRC3D = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => {
        setCurrentIndex((prev) =>
            prev === images.length - 1 ? 0 : prev + 1
        );
    };

    const prevImage = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? images.length - 1 : prev - 1
        );
    };

    return (
        <div className="container">
            <FloatingWhats/>
            <Header/>    
            <div className="content">
                <div className="bannerInterno-container from-top">
                    <div className="bannerInterno-content">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">BRC3<br/>Digital</h1>
                            <img className="bannerInterno-img" src="/images/banner-brc3d.png" alt="Banner Célula BRC3D"/>
                        </div>
                    </div>
                </div>
                <div className="caminho">
                    <div className="caminho-content from-left">
                        <a className="caminho-link" href="/">Início</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos">Produtos</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos/pesagem-rodoviaria">Pesagem Rodoviária</a>
                        <span className="caminho-separador">/</span>
                        <span className="caminho-atual">BRC3-D</span>
                    </div>
                </div>
                <div className="produto-header">
                    <div className="produto-header-content">
                        <div className="produto-header-left from-left">
                            <div className="produto-header-fotosBox">
                                <img className="produto-header-foto" src={images[currentIndex]} alt="Produto" />
                                <button className="produto-header-btn left" onClick={prevImage}><ChevronLeftIcon sx={{ fontSize: 40 }}/></button>
                                <button className="produto-header-btn right" onClick={nextImage}><ChevronRightIcon sx={{ fontSize: 40 }} /></button>
                            </div>
                        </div>
                        <div className="produto-header-right from-right">
                            <div className="produto-header-infoBox">
                                <div className="produto-header-infoBox1">
                                    <h1 className="produto-header-name from-right">BRC3 Digital</h1>
                                    <h4 className="produto-header-sku from-right">ID:506010</h4>
                                </div>
                                <div className="produto-header-descricao">
                                    <span className="produto-header-info"><strong>Fabricante:</strong> Berman</span>
                                    <span className="produto-header-info"><strong>Tipo de Sinal:</strong> Digital</span>
                                    <span className="produto-header-info"><strong>Classe de Proteção:</strong> IP69K</span>
                                    <span className="produto-header-info"><strong>Material:</strong> Aço Inoxidável</span>
                                    <span className="produto-header-info"><strong>Capacidade Máxima:</strong> 50 Toneladas</span>
                                </div>
                                <div className="produto-header-infoBox3">
                                    <h3 className="produto-header-chamada">
                                        <span style={{color:'#474747'}}>Alguma Dúvida?</span>
                                    </h3>
                                    <a href="https://wa.me/+556599547518"><Button sx={{fontFamily:'Inter', textTransform:'none', width:'100%', height:90, backgroundColor:'#474747', borderRadius:'8px', color:'#fff', fontSize:'20px','&:hover':{backgroundColor:'#7D1115'}}}>Falar com Vendedor</Button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="downloads">
                    <div className="downloads-content">
                        <h3 className="downloads-title">Arquivos para Download</h3>
                        <div className="downloads-links">
                            <a className="downloads-link" href="https://drive.google.com/file/d/1-WIbj0rKPShNRKo7_WbAiAeUIQILzd2x/view?usp=drive_link" target="_blank" rel="noopener noreferrer"><img src="/images/icons/arquivo.svg" className="download-icon"/>Ficha Técnica</a>
                        </div>
                    </div>
                </div>
                <div className="cel-descricao">
                    <div className="cel-descricao-content">
                        <h2 className="cel-descricao-title">Descrição</h2>
                        <div className="cel-descricao-text">
                            <h3>Versatilidade e ótimo custo-benefício com grau de proteção IP69k, ideal para pesagem rodoviária em aplicações severas. Capacidade unitária de até 50t.</h3>
                            <h3>Principais características</h3>
                            <ul>
                                <li>Construída em aço inoxidável, que proporciona resistência à corrosão, tornando-se durável, mesmo em ambientes com condições adversas.</li>
                                <li>Máxima proteção contra infiltração de água, mesmo com o uso de jatos de alta pressão ou limpeza a vapor.</li>
                                <li>As castanhas anti rotação tornam a montagem mais segura e resistente, além de permitir movimentação lateral com até 3° de inclinação (seguindo o sentido longitudinal da plataforma).</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="cel-dimensao">
                    <div className="cel-dimensao-content">
                        <h2 className="cel-dimensao-title">Dimensões (mm)</h2>
                        <img className="cel-dimensao-img" src="/images/dim-brc3a.png" alt="Dimensões Célula BRC3A"/>
                        <h2 className="cel-dimensao-title">Dimensões com castanhas (mm)</h2>
                        <img className="cel-dimensao-img" src="/images/dim2-brc3a.png" alt="Dimensões Célula BRC3A 2"/>
                    </div>
                </div>
                <div className="model">
                    <div className="model-content">
                        <iframe src="https://weightech2.autodesk360.com/shares/public/SH286ddQT78850c0d8a4243c24fe6290a98e?mode=embed" height="450" width="100%"></iframe>
                    </div>
                </div>


                <BottomBar/>
                <Footer/>
            </div>
        </div>
    )
}
export default ProdCelBRC3D;